module.exports = __webpack_public_path__ + "img/paraf.d3c863ba.svg";